






















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ApiHelper from '~/helpers/api-helper';
import BudgetPackageSelect from '~/components/inputs/BudgetPackageSelect.vue';
import CountrySelect from '~/components/inputs/CountrySelect.vue';
import CitySelect from '~/components/inputs/CitySelect.vue';

@Component({
	components: {
		BudgetPackageSelect,
		CountrySelect,
		CitySelect,
	},
})
export default class PackageFilter extends Vue {
	@Prop({ default: {}, required: true }) private filters;
	@Prop({ default: '', required: true }) private title;

	private valueBudget: any = null;
	private valueCountry: any = null;
	private valueCity: any = null;
	private filtersData: any = {};

	@Watch('filters')
	filters_change(value) {
		this.filtersData = value;
		if (value.budget) {
			this.valueBudget = value.budget;
		}
		if (value.country_id) {
			this.valueCountry = value.country_id;
		}
		if (value.city_id) {
			this.valueCity = value.city_id;
		}
	}

	mounted() {
		if (this.filters) {
			this.filtersData = this.filters;
		}
		if (this.$route.query.budget) {
			this.valueBudget = this.$route.query.budget;
		}
		if (this.$route.query.country_id) {
			this.valueCountry = this.$route.query.country_id;
		}
		if (this.$route.query.city_id) {
			this.valueCity = this.$route.query.city_id;
		}
	}

	prepareFilter(data) {
		if (data.budget && data.budget != 0) {
			this.filtersData['budget'] = data.budget;
		} else if (data.hasOwnProperty('budget') && data.budget == 0) {
			delete this.filtersData['budget'];
		}
		if (data.country_id) {
			this.filtersData['country_id'] = data.country_id;
		} else if (data.hasOwnProperty('country_id') && data.country_id == null) {
			delete this.filtersData['country_id'];
		}
		if (data.city_id) {
			this.filtersData['city_id'] = data.city_id;
		} else if (data.hasOwnProperty('city_id') && data.city_id == null) {
			delete this.filtersData['city_id'];
		}
	}

	searchPackage() {
		this.$emit('searchPackage');
	}
}
